import {
  addDoc,
  collection,
  Timestamp,
  onSnapshot,
  query,
  orderBy,
  writeBatch,
} from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import { SessionDeCharge } from "../types/BMW";

const COLLECTION_NAME = "sessionsDeCharge";

/* =========================
   ➕ Ajouter une session
========================= */
export const addSession = async (data: Omit<SessionDeCharge, "id">) => {
  await addDoc(collection(db, COLLECTION_NAME), {
    ...data,
    date: Timestamp.fromDate(new Date()), // ou data.date si tu le passes
  });
};

/* =========================
   👀 Écoute temps réel
========================= */
export const listenSessions = (callback: (data: SessionDeCharge[]) => void) => {
  const q = query(collection(db, COLLECTION_NAME), orderBy("date", "desc"));

  return onSnapshot(q, (snapshot) => {
    const sessions = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as SessionDeCharge[];

    callback(sessions);
  });
};

/* =========================
   ✏️ Update
========================= */
export const updateSession = async (
  id: string,
  data: any
) => {
  const ref = doc(db, COLLECTION_NAME, id);
  await updateDoc(ref, data);
};

/* =========================
   🗑 Delete
========================= */
export const deleteSession = async (id: string) => {
  const ref = doc(db, COLLECTION_NAME, id);
  await deleteDoc(ref);
};

